const JOURS = ['DIMANCHE','LUNDI','MARDI','MERCREDI','JEUDI','VENDREDI','SAMEDI']; // Index 0-6 correspond aux jours

/**
 * Entrée (backend): [{ jour:number(0-6), heureDebut:string, heureFin:string, actif:boolean, ordre?:number }]
 * Sortie (UI attendue): [{ jour:string(JOUR), creneaux:[{heureDebut, heureFin, actif, ordre?}]}]
 */
export function normalizeHoraires(raw) {
  const byJour = new Map(); // key: 0..6 -> { jour:'LUNDI', creneaux:[] }
  (Array.isArray(raw) ? raw : []).forEach(h => {
    const idx = typeof h?.jour === 'number' ? h.jour : null;
    if (idx == null || idx < 0 || idx > 6) return;
    if (!byJour.has(idx)) {
      byJour.set(idx, { jour: JOURS[idx], creneaux: [] });
    }
    byJour.get(idx).creneaux.push({
      heureDebut: h?.heureDebut ?? '',
      heureFin:   h?.heureFin ?? '',
      actif:      Boolean(h?.actif),
      ordre:      typeof h?.ordre === 'number' ? h.ordre : 0,
      libelleLieu: h?.libelleLieu ?? '',
      adresseLigne1: h?.adresseLigne1 ?? '',
      adresseLigne2: h?.adresseLigne2 ?? '',
      codePostal: h?.codePostal ?? '',
      ville: h?.ville ?? '',
      latitude: h?.latitude !== undefined && h?.latitude !== null ? String(h.latitude) : '',
      longitude: h?.longitude !== undefined && h?.longitude !== null ? String(h.longitude) : ''
    });
  });
  // Tri par jour dans l'ordre attendu par l'interface : Lundi à Dimanche
  const joursOrder = [1, 2, 3, 4, 5, 6, 0]; // Lundi(1) à Dimanche(0)
  return joursOrder
    .map(jourNum => byJour.get(jourNum))
    .filter(Boolean)
    .map(val => ({
      ...val,
      creneaux: [...val.creneaux].sort((a,b) => (a.ordre||0) - (b.ordre||0))
    }));
}

export const __JOURS = JOURS;
